import React from 'react';
import classNames from 'classnames';

export function Navbar({
  children,
  className,
  light,
  dark,
  color,
  expand,
  fixed,
  sticky,
  tag: Tag = 'nav',
  ...rest
}) {
  return (
    <Tag
      {...rest}
      className={classNames(
        'relative flex flex-wrap items-center justify-between px-4 py-2',
        light && 'bg-white text-gray-900',
        dark && 'bg-gray-900 text-white',
        className
      )}
    >
      {children}
    </Tag>
  );
}

export function Nav({
  children,
  className,
  navbar = false,
  vertical = false,
  tag: Tag = 'ul',
  ...rest
}) {
  return (
    <Tag
      {...rest}
      className={classNames(
        'm-0 flex list-none p-0',
        vertical ? 'flex-col' : 'flex-row',
        className
      )}
    >
      {children}
    </Tag>
  );
}

export function NavItem({ children, className, tag: Tag = 'li', ...rest }) {
  return (
    <Tag {...rest} className={classNames('list-none', className)}>
      {children}
    </Tag>
  );
}

export function NavLink({
  children,
  className,
  href,
  tag,
  onClick,
  active,
  disabled,
  ...rest
}) {
  const Tag = tag || (href ? 'a' : 'button');
  return (
    <Tag
      {...rest}
      href={Tag === 'a' ? href : undefined}
      type={Tag === 'button' ? rest.type || 'button' : undefined}
      onClick={onClick}
      disabled={disabled}
      className={classNames(
        'block cursor-pointer border-0 bg-transparent px-3 py-2 text-[var(--color-info)] no-underline whitespace-nowrap hover:underline focus:outline-none disabled:cursor-default disabled:opacity-50',
        active && 'font-bold',
        className
      )}
    >
      {children}
    </Tag>
  );
}
